import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { TokenWithBalance, TokenWithFormValue } from '@/domain/common/types'
import { z } from 'zod'

export interface FormFieldsForDialog {
  selectedFromAsset: TokenWithFormValue
  selectedToAsset: TokenWithFormValue
  maxValue: NormalizedUnitNumber
  maxSelectedFieldName?: string // can't be used with maxValue
  changeFromAsset: (newSymbol: TokenSymbol) => void
  changeToAsset: (newSymbol: TokenSymbol) => void
  changeFromValue: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSetMax: (max: NormalizedUnitNumber) => void
  displayBalance?: NormalizedUnitNumber
  fromAssets: TokenWithBalance[]
  toAssets: TokenWithBalance[]
}

export type GsmMintState = {
  message: string
  status: 'idle' | 'in-progress' | 'error'
}

export class GSMMintError extends Error {
  public details?: Record<string, unknown>

  constructor(message: string, details?: Record<string, unknown>) {
    super(message)
    this.name = 'GSMMintError'
    this.details = details
  }
}

export type GsmBurnState = {
  message: string
  status: 'idle' | 'in-progress' | 'error'
}

export class GSMBurnError extends Error {
  public details?: Record<string, unknown>

  constructor(message: string, details?: Record<string, unknown>) {
    super(message)
    this.name = 'GSMBurnError'
    this.details = details
  }
}

export const UsdxlIncentivesObjectSchema = z.object({
  recipientAddress: z.string(),
  currencyAddress: z.string(),
  currencyChainId: z.number(),
  amount: z.string(),
})

export const UsdxlIncentivesResponseSchema = z.array(UsdxlIncentivesObjectSchema)

export type UsdxlIncentivesObject = z.infer<typeof UsdxlIncentivesObjectSchema>
export type UsdxlIncentivesResponse = z.infer<typeof UsdxlIncentivesResponseSchema>

export const UsdxlIncentivesAprObjectSchema = z.object({
  name: z.string(),
  metrics: z.object({
    apr: z.string(),
  }),
})

export const UsdxlIncentivesAprResponseSchema = z.array(UsdxlIncentivesAprObjectSchema)

export type UsdxlIncentivesAprObject = z.infer<typeof UsdxlIncentivesAprObjectSchema>
export type UsdxlIncentivesAprResponse = z.infer<typeof UsdxlIncentivesAprResponseSchema>

export class UsdxlBalanceRewardsClaimError extends Error {
  public details?: Record<string, unknown>

  constructor(message: string, details?: Record<string, unknown>) {
    super(message)
    this.name = 'UsdxlBalanceRewardsClaimError'
    this.details = details
  }
}

// Fuul v2 ClaimCheck types
export const ClaimCheckSchema = z.object({
  project_address: z.string(),
  to: z.string(),
  currency: z.string(),
  currency_type: z.number(),
  amount: z.string(),
  reason: z.number(),
  token_id: z.string(),
  deadline: z.number(),
  proof: z.string(),
  signatures: z.array(z.string()),
})

export const ClaimableChecksResponseSchema = z.array(ClaimCheckSchema)

export type ClaimCheck = z.infer<typeof ClaimCheckSchema>
export type ClaimableChecksResponse = z.infer<typeof ClaimableChecksResponseSchema>
